/*Mahesh S  : 05-10-2023 : BT-105135 -  Breeze- Portfolio Holdings - Start*/
import { memo } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { BzButton, BzHeading } from "../../../components";
import { getExchangeWiseScripInfo, getScripOrderInfo } from "../../../redux/actions/orders";
import { handleModal, handleModalData } from "../../../redux/actions/modals";
import { ORDER_ENTRY_GRID_REF, convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId } from "../../../utils/global_functions";
import { ORDER_PRODUCT_TYPES, WATCHLIST_GRID_INDEX } from "../../../utils/global_variables";
//Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - Start
import { useDispatch, useSelector } from "react-redux";
import { toastConfig } from "../../../redux/actions/toast";
import { _getProductType } from "../../../controllers";
//Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - End

const HoldingGridDetails = ({ ...props }) => {
    const dispatch = useDispatch();
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    //Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - Start
    const productTypeData = useSelector(state => state?.orders?.productTypes);
    const handleBuySell = (holdingsDetails, type, event) => {
        const strProductTypeDesc = _getProductType(ORDER_PRODUCT_TYPES.DELIVERY, getApiExchangeNameFromMktSegId(holdingsDetails?.nMarketSegmentId), productTypeData, objLoginSession);
        const strExchangeName = getApiExchangeNameFromMktSegId(holdingsDetails?.nMarketSegmentId);
        if (objLoginSession?.data?.exchanges?.includes(strExchangeName?.toUpperCase())) {
            dispatch(getExchangeWiseScripInfo(holdingsDetails));
            dispatch(handleModal([{ "ORDER_ENTRY_MODAL": true }]));
            // Vaibhav S : 26-02-2024 : added data upadtion logic:Start
            ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: holdingsDetails.ltp, scripLot: type === 'SELL' ? holdingsDetails?.qty : 1 }));
            ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(prev => ({ ...prev, productType: ORDER_PRODUCT_TYPES.DELIVERY, productTypeDesc: strProductTypeDesc, isDefaultProductType: false }));
            // Vaibhav S : 26-02-2024 : added data upadtion logic:End
            dispatch(handleModalData({ rowDetails: holdingsDetails }));
            const arrHoldingsDetails = convertScripResponseWatchlistGrid(holdingsDetails?.ScripData);
            dispatch(getScripOrderInfo({ activeExchangeId: arrHoldingsDetails[WATCHLIST_GRID_INDEX?.SEGMENT_ID], isBuySell: type === 'BUY' ? 0 : 1, scripData: arrHoldingsDetails[0], bIsHoldingsSell: type === 'SELL' ? true : false }));//  Azeem K : 27-02-2024 : BT-102298 - Breeze - Single Scrip Order entry - BSEEQ   bIsHoldingsSell added
        } else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `You are currently not allowed to place/modify/cancel order in this segment` }));
        }
    };
    //Prachi T :BT-107377 - 17-11-2023 ScripInnfo recommendations - End

    return (
        <Container fluid className='p-0'>
            <Row className='g-0'>
                <Col className='mrgauto p-3'>
                    <Row className='g-0 my-3'>
                        <Col md={6} className='d-flex justify-content-start align-items-center'>
                            <BzHeading className='font-medium font-size4 color-text'>Additional Details</BzHeading>
                        </Col>
                        <Col md={6} className='d-flex justify-content-end align-items-center'>
                            <BzButton className='btn btn-sm btn-positive text-capitalize ms-3' onClick={() => handleBuySell(props?.data, 'BUY')}>BUY</BzButton>
                            <BzButton className='btn btn-sm btn-negative text-capitalize ms-3' onClick={() => handleBuySell(props?.data, 'SELL')}>SELL</BzButton>
                        </Col>
                    </Row>
                    <Row className='g-0'>
                        <Col>
                            {/*have to use direct props */}
                            {props?.data &&
                                <table className='table table-sm table-hover table-bordered table-striped'>
                                    <thead>
                                        <tr>
                                            <td className='text-center'>
                                                <div className='font-medium font-size2 color-text text-capitalize py-2'>&nbsp;</div>
                                            </td>
                                            <td className='text-center'>
                                                <div className='font-medium font-size2 color-text text-capitalize py-2'>Available Qty.</div>
                                            </td>
                                            <td className='text-center'>
                                                <div className='font-medium font-size2 color-text text-capitalize py-2'>Block Qty.</div>
                                            </td>
                                            <td className='text-center'>
                                                <div className='font-medium font-size2 color-text text-capitalize py-2'>Pledged Qty.</div>
                                            </td>
                                            <td className='text-center'>
                                                <div className='font-medium font-size2 color-text text-capitalize py-2'>Free Qty.</div>
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <>
                                            <tr>
                                                <td className='text-center'>
                                                    <div className='font-medium font-size2 color-text text-capitalize py-1'>Today's</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.sCurRecvAvailable}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.sCurRecvBlock}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.sCurRecvPledge}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.sCurvRecvFree}</div>
                                                </td>
                                            </tr>
                                            <tr >
                                                <td className='text-center'>
                                                    <div className='font-medium font-size2 color-text text-capitalize py-1'>Stock Receivable</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.sRecvAvailable}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.nTotalRecvBlock}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.sRecvPledge}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.sRecvFree}</div>
                                                </td>
                                            </tr>
                                            <tr >
                                                <td className='text-center'>
                                                    <div className='font-medium font-size2 color-text text-capitalize py-1'>Pool</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.sPOOLAvailable}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.nTotalPOOLBlock}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.nPOOLPledgeCollateralQty}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.sPOOLFree}</div>
                                                </td>
                                            </tr>
                                            <tr >
                                                <td className='text-center'>
                                                    <div className='font-medium font-size2 color-text text-capitalize py-1'>DP</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.sDPAvailable}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.nTotalDPBlock}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.nDPPledgeCollateralQty}</div>
                                                </td>
                                                <td className='text-center'>
                                                    <div className='font-regular font-size2 color-text text-capitalize py-1'>{props?.data?.sDPFree}</div>
                                                </td>
                                            </tr>

                                        </>
                                    </tbody>
                                </table>}
                        </Col>
                    </Row>
                </Col>
            </Row>

        </Container>
    );
};

export default memo(HoldingGridDetails);

/*Mahesh S  : 05-10-2023 : BT-105135 -  Breeze- Portfolio Holdings - End*/